<div class="directionLtr compareable_chart_container">
  <div class="dashboard-header">
    <div *ngIf="hasExpandedYears" (click)="resetExpandedYears()" class="reset-icon-overlap"
          [matTooltip]="'reports.collapse_all' | translate" matTooltipPosition="before">
      <img src="../../../../../assets/images/tabler-icon-rotate-clockwise.svg" alt="Collapse All" class="reset-img">
    </div>
  </div>
  <div [id]="chartId" style="min-width: 100%; height: 350px;"></div>
</div>